import Api from './UserManagement.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { UserManagementConstants } from './UserManagement.constants';
import { isEmpty as _isEmpty, forEach as _forEach, find as _find } from 'lodash-es';
import Cookies from 'js-cookie';
import { apiServices } from 'redux/utils/api_services';
import { getIsDemoHost } from 'utilities/demo_utilities';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const auth = new Api('services/authToken/v1', 'auth');
const accountDetails = new Api('services/', 'account');

// !-- on login
export const onLogin = props => {
  return async dispatch => {
    try {
      dispatch({ type: UserManagementConstants.GET_AUTH_LOGIN_REQUEST });

      let apiData = await auth.onLogin(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: UserManagementConstants.GET_AUTH_LOGIN_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: UserManagementConstants.GET_AUTH_LOGIN_ERROR });
      throw new UserError(error);
    }
  };
};

// !-- check login
export const onCheckLogin = () => {
  return async dispatch => {
    try {
      dispatch({ type: UserManagementConstants.GET_AUTH_LOGIN_REQUEST });

      let isAuthorized = await auth.onCheckLogin();
      if (isAuthorized) {
        const userData = auth.getUser();
        if (userData) {
          // !-- on Login success
          dispatch({
            type: UserManagementConstants.GET_AUTH_LOGIN_SUCCESS,
            payload: { userData, loading: false, authorized: true, loginError: null }
          });

          // ?-- Add all API calls after login success
          dispatch(getAccountDetails());
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      dispatch({
        type: UserManagementConstants.GET_AUTH_LOGOUT
      });
    }
  };
};

// !-- on logout
export const onLogout = async (isManualLogout = false) => {
  logoutAccount();
  // *! NEED TO OPTIMIZE THIS CODE.
  function deleteCookie(name) {
    document.cookie =
      name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + process.env.REACT_APP_COOKIE_PATH + ';path=/';
  }
  // List of cookies to delete
  const cookiesToDelete = [
    'accessToken',
    'oldAccessToken',
    'refreshToken',
    'oldRefershToken',
    'timeCreated',
    'locale',
    'chromeExtensionRemindLater',
    'accountNumber',
    'userId',
    'merchantID',
    'username',
    'isRCAZeroIndexLoaded'
  ];
  const dynamicCookieKeys = ['IsExpiryPopUpShown', 'isChannelAuthPopupLoaded'];
  const cookieDomain = process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_PATH;
  _forEach(cookiesToDelete, cookieName => {
    document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${cookieDomain};path=/`;
  });
  const cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/);
  _forEach(cookieNames, cookieName => {
    _forEach(dynamicCookieKeys, key => {
      if (cookieName.includes(key)) {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${cookieDomain};path=/`;
      }
    });
  });
  deleteCookie('accessToken');
  deleteCookie('refreshToken');
  deleteCookie('locale');
  // Clear all localStorage except CleverTap
  Object.keys(localStorage).forEach(key => {
    if (!key.startsWith('WZRK')) {
      localStorage.removeItem(key);
    }
  });
  sessionStorage.clear();
  sessionStorage.setItem('isManualLogout', isManualLogout);
  localStorage.removeItem('user_metadata');
  const isDemoHost = getIsDemoHost();
  let redirectUrl = `/login`;
  if (isDemoHost) {
    redirectUrl = `/demo-login`;
  }
  window.location.href = window.location.origin + redirectUrl;
  // window.location.reload();
};

// !-- Get account details
export const getAccountDetails = () => {
  return async dispatch => {
    try {
      dispatch({ type: UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_REQUEST });
      let apiData = await accountDetails.getAccountDetails();
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        let { data } = apiData;
        dispatch({ type: UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_SUCCESS, payload: data });
        if (!_isEmpty(data)) {
          const locales = data?.localesSupported || [];
          if (!_isEmpty(locales)) {
            const found = _find(locales, l => l?.isDefault) || {};
            Cookies.set('locale', found?.locale || 'en_US', {
              expires: 1,
              domain: process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_PATH
            });
            let updatedArray = [];
            _forEach(locales, locale => {
              updatedArray?.push({
                key: locale?.locale,
                label: locale?.DisplayName || locale?.displayName,
                default: locale?.isDefault
              });
            });
            dispatch({ type: UserManagementConstants.SET_LOCALES, payload: updatedArray });
            localStorage.setItem('supportedLocales', JSON.stringify(updatedArray));
          }
        }
      }
    } catch (error) {
      console.log('reacted here', error);
      dispatch({ type: UserManagementConstants.GET_AUTH_ACCOUNT_DETAILS_ERROR });
      throw new UserError(error);
    }
  };
};

const logoutAccount = async () => {
  const token = `Bearer ${auth.getAccessToken()}`;
  await fetch(`${apiServices['auth']}services/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authType: 'graas',
      Authorization: `${token}`
    }
  })
    .then(response => {
      if (!response.ok) {
        return response.text();
      }
    })
    .catch(error => {
      console.error('Fetch error:', error);
    });
};

export const getSubUserMenu = userId => {
  return async dispatch => {
    try {
      dispatch({ type: UserManagementConstants.GET_SUB_USER_MENU_REQUEST, payload: userId });
      const apiData = await accountDetails.getSubUserMenu(userId);
      if (apiData && apiData.hasError) {
        throw new Error();
      } else {
        let { data } = apiData;
        data.userId = userId;
        dispatch({ type: UserManagementConstants.GET_SUB_USER_MENU_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: UserManagementConstants.GET_SUB_USER_MENU_ERROR, payload: userId });
      throw new UserError(error);
    }
  };
};
